import { CommandResult } from './../../domain/commandResult';
import { Component, OnInit, AfterContentInit } from '@angular/core';
import { FabricantedeService } from 'src/app/pages/cadastros/services/fabricante.service';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsuarioService } from 'src/app/services/usuario.service';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { TipoMaterialService } from 'src/app/services/tipo-material.service';
import { TipoMaterial } from '../../domain/domain.model';

@Component({
  selector: 'app-tipo-material',
  templateUrl: './tipo-material.component.html',
  styleUrls: ['./tipo-material.component.sass']
})
export class TipoMaterialComponent implements OnInit, AfterContentInit {

  
  public cadastrados: TipoMaterial[] = [];

  public form: FormGroup = null;
  public id = 0; // representa o id do modelo. Se 0 novo cadastro, Se > 0 editando
  public isProcessing = false;
  public isEditing = false;
  public voids: string[] = [];
  public maxRowsVoids = 7;

  public autorizacoes: UsuarioAutorizacoes;

  constructor(
    private tipoMaterialService: TipoMaterialService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder

  ) { }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('tipo-material');
  }

  ngOnInit() {
    this.getAll(); // carrega lista de já cadastrados
    this.resetForm(); // instancia o formulário utilizado (formGroup)
  }

  public getAll(): void {
    this.tipoMaterialService.getAll().subscribe((response: TipoMaterial[]) => {
      this.cadastrados = response;
      this.setVoids();
    });
  }

  public resetForm(): void {
    this.form = this.formBuilder.group(
      {
        id: [0],
        descricao: ['', [Validators.required]]
      }
    );
  }

  public reset(): void {
    this.id = 0;
    this.isProcessing = false;
    this.isEditing = false;
    this.resetForm();
  }

  public getById(id: number): void {

    this.reset();
    this.isProcessing = true;

    this.tipoMaterialService.getById(id).subscribe(

      (response: TipoMaterial) => {
        this.form.get('descricao').setValue(response.descricao);
        this.form.get('id').setValue(response.id);
        this.id = id;
        this.isEditing = true;
        this.isProcessing = false;
      },
      (error: any) => {
        this.showError(error);
      },
    );
  }

  public submit(): void {

    this.isProcessing = true;

    
      this.tipoMaterialService.alreadyRegistered(this.form.get('id').value, this.form.get('descricao').value).subscribe(

        (alreadRegistrered: boolean) => {

          if (alreadRegistrered == false) {
            this.save();
          } else {
            this.form.get('descricao').setErrors({ isNotUniqueDescricao: true });
            this.isProcessing = false;
          }
        },
        (error: any) => { this.showError(error); }
      );
   

  }

  private save() {
    this.tipoMaterialService.post(this.form.value as TipoMaterial).subscribe(

      (response: CommandResult) => {

        if (response.success == true) {
          this.toastr.success(response.message);
        } else {
          this.toastr.warning(response.message);
        }
        this.reset();
        this.getAll();
      },
      (error: any) => {
        this.showError(error);
      }
    );

  }


  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) { this.voids.push(''); }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, { windowClass: 'smModal', backdrop: 'static'  });
  }

  public delete(id: number, c: any): void {

    this.isProcessing = true;
    c('Close click');

    this.tipoMaterialService.remove(id).subscribe(

      (response: any) => {

        if (response.success == true) {
          this.toastr.success(response.message);
        } else {
          this.toastr.warning(response.message);
        }
        this.reset();
        this.getAll();
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public showError(error: any) {

    this.form.get('nome').setErrors({ hasError: true });

    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error('Ocorreu um erro no servidor');
    }

    this.isProcessing = false;
  }


}
